import { Checkbox, FormControlLabel, Link, Typography } from "@mui/material";
import { storeChildWindows } from "../../../../explorer/utils/UtilsFunctions";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import { useFormClasses } from "./CreateOfferOrderForm.style";
import { LinkOrderAgreementStyled } from "./OrderAgreement.style";

type CGVAgreementProps = {
  value: boolean;
  onChange: (event: any, checked: any) => void;
  setEnable:any
  enable:boolean;
};

const CGVAgreement: React.FC<CGVAgreementProps> = (props) => {
    const { t } = useTranslation();
    const classesForm = useFormClasses();

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        color="primary"
                        name="ExpandAll"
                        value={props.value}
                        onChange={(event, checked) => {
                            props.onChange(event, checked);
                        }}
                        sx={classesForm.checkbox}
                        disabled={!props.enable}
                    />
                }
                label={
                    <Typography
                        component="span"
                        sx={classesForm.title}
                        id="orderAgreement"
                    > 
                        {t("orderoffer.cgvAgreement")}
                    </Typography>
                }
                labelPlacement="end"
                //style={{ marginLeft: "0", alignItems: "start" }}
            />
        </>
    );
};
export default CGVAgreement;
